import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../../components/panel/panel";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import axiosClient from "../../../../../config/axios.js";

function EditVehicleType() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { Formik } = formik;

  const [initialValues, setInitialValues] = useState({
    vehicle_type_name: "",
    is_visible: true,
  });

  useEffect(() => {
    axiosClient
      .get(`/vehicleTypes/${id}`)
      .then((response) => {
        const { vehicle_type_name, is_visible } = response.data;
        setInitialValues({
          vehicle_type_name,
          is_visible: is_visible ?? true,
        });
      })
      .catch((error) => {
        console.error("Error fetching vehicle type data:", error);
      });
  }, [id]);

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item">
              <Link to="/catalogs/brandsModels?tab=typesVehicles">
                Tipos de Vehículos
              </Link>
            </li>
            <li className="breadcrumb-item active">Edición de Tipo</li>
          </ol>
          <h1 className="page-header mb-0">Edición de Tipo de Vehículo</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Edición de Tipo de Vehículo</PanelHeader>
            <PanelBody>
              <Formik
                enableReinitialize
                validationSchema={yup.object().shape({
                  vehicle_type_name: yup
                    .string()
                    .required("Ingrese el nombre del tipo de vehículo"),
                })}
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(false);

                  Swal.fire({
                    title: "¿Guardar cambios?",
                    text: "¿Deseas actualizar este tipo de vehículo?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Sí, guardar",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      axiosClient
                        .put(`/vehicleTypes/${id}`, values)
                        .then(() => {
                          Swal.fire({
                            title: "Cambios guardados",
                            text: "El tipo de vehículo se ha actualizado exitosamente.",
                            icon: "success",
                            confirmButtonText: "Cerrar",
                          });
                          // navigate("/catalogs/brandsModels?tab=typesVehicles");
                        })
                        .catch((err) => {
                          let message = "";
                          if (err.response?.data?.original?.code === "23505") {
                            message =
                              "El tipo de vehículo ya existe. Ingresa uno diferente.";
                          } else {
                            message =
                              err.response?.data?.message ||
                              "Error al actualizar el tipo de vehículo.";
                          }
                          Swal.fire({
                            title: "Ups!",
                            text: message,
                            icon: "error",
                            confirmButtonText: "Cerrar",
                          });
                        });
                    }
                  });
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  errors,
                  setFieldValue,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="12">
                        <Form.Label>Nombre del Tipo de Vehículo</Form.Label>
                        <Form.Control
                          type="text"
                          name="vehicle_type_name"
                          placeholder="Ejemplo: Camión, Sedan, SUV..."
                          value={values.vehicle_type_name}
                          onChange={handleChange}
                          isInvalid={!!errors.vehicle_type_name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.vehicle_type_name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    {/* Switch para mostrar/ocultar */}
                    <Row className="mb-3">
                      <Form.Group as={Col} md="12">
                        <Form.Check
                          type="switch"
                          id="is_visible"
                          label="Mostrar en la lista de tipos de vehículos"
                          checked={values.is_visible}
                          onChange={(e) =>
                            setFieldValue("is_visible", e.target.checked)
                          }
                        />
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Col md="12">
                        <Button type="submit">Guardar Cambios</Button>{" "}
                        <Link
                          to="/catalogs/brandsModels?tab=typesVehicles"
                          className="btn btn-info"
                        >
                          Regresar
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default EditVehicleType;
